module.exports = __webpack_public_path__ + "static/img/bg.bfb0c1d3.jpg";